import React, { useState, useEffect } from 'react';
import { post } from '../components/Auths/AuthToken';
import setUiMessage from './Tostify';

function SelectServiceCode({ serviceCode, patId, returnData }) {
  const [pocSerVal, setPocSerVal] = useState(serviceCode || '');
  const [selected, setSelected] = useState(false);
  const [showProcDd, setShowProcDd] = useState(false);
  const [allSerData, setAllSerData] = useState([]);

  useEffect(() => {
    setPocSerVal(serviceCode);
  }, [serviceCode]);

  useEffect(() => {
    if (pocSerVal && pocSerVal.length >= 3 && selected) {
      (async () => {
        try {
          const response = await post(
            'api/patient/progressNote/getProcedureListForDropdown',
            {
              term: pocSerVal,
              searchCodeType: '1',
              patientId: patId,
            }
          );
          if (response.status === 200) {
            setShowProcDd(true);
            setAllSerData(response?.data);
          }
        } catch (err) {
          setUiMessage('err', err.message);
        }
      })();
    } else {
      setShowProcDd(false);
      setAllSerData([]);
    }
  }, [pocSerVal, patId, selected]);

  const handelProcSelect = (id, val, text, specificProId) => {
    setShowProcDd(false);
    setSelected(false);
    setPocSerVal(val);
    returnData(id, val, text, specificProId);
  };
  return (
    <div className="insu-act-sec-bdy-lft flex-sec">
      <span className="nsu-act-lbl">
        Service Code:<span className="required-fld">*</span>
      </span>
      <span className="nsu-act-val">
        <input
          type="serch"
          className="inpt-width-nw"
          placeholder="Please search code here..."
          id="servicecode"
          name="servicecode"
          value={pocSerVal || ''}
          onChange={(e) => {
            setPocSerVal(e.target.value);
            setSelected(true);
          }}
        />
      </span>
      {allSerData.length > 0 && showProcDd && (
        <div
          className="proc-list-dd"
          style={{ left: '145px', top: '190px', zIndex: '10', width: '496px' }}
        >
          {allSerData &&
            allSerData.map((item, i) => (
              <div
                key={i}
                style={{
                  padding: '10px',
                  borderBottom: '1px solid #ccc',
                }}
                onClick={() =>
                  handelProcSelect(
                    item?.id,
                    item?.code,
                    item?.name,
                    item?.specificProId
                  )
                }
              >
                {item.name}
              </div>
            ))}
        </div>
      )}
    </div>
  );
}

export default SelectServiceCode;
